var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.709,
    height: 15.957,
    viewBox: "0 0 22.709 15.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M23.695,9.882a8.768,8.768,0,0,0-.939-4.26A3.012,3.012,0,0,0,20.982,4.59a80.835,80.835,0,0,0-8.634-.32,80.921,80.921,0,0,0-8.6.309,2.961,2.961,0,0,0-1.506.763C1.31,6.2,1.207,7.664,1.1,8.9a49.812,49.812,0,0,0,0,6.685,9.851,9.851,0,0,0,.309,2.063,3.239,3.239,0,0,0,.732,1.4,2.95,2.95,0,0,0,1.537.8,46.606,46.606,0,0,0,6.705.34c3.61.052,6.777,0,10.522-.289a2.971,2.971,0,0,0,1.578-.8,2.569,2.569,0,0,0,.629-1.032,10.914,10.914,0,0,0,.536-3.507C23.695,13.988,23.695,10.5,23.695,9.882Zm-13.679,5.3V8.8l6.107,3.208C14.411,12.956,12.151,14.029,10.016,15.184Z",
    transform: "translate(-0.991 -4.258)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2215ffd1b7f8a57b6ee186fd63c2fc19.svg";
export { ForwardRef as ReactComponent };